var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPerformancetesting = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 78,
    viewBox: "0 0 87 78",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4501 39.475C82.4501 20.5876 67.1375 5.27499 48.25 5.27499C29.3626 5.27499 14.05 20.5876 14.05 39.475C14.05 58.3624 29.3626 73.675 48.25 73.675C67.1375 73.675 82.4501 58.3624 82.4501 39.475Z",
    fill: "#D0EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 39.475C86.5 18.3502 69.3748 1.22501 48.25 1.22501C27.1252 1.22501 10 18.3502 10 39.475C10 60.5998 27.1252 77.725 48.25 77.725C69.3748 77.725 86.5 60.5998 86.5 39.475Z",
    stroke: "#A4B8D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.91 4.55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3 35.2C70.3 20.6614 58.5136 8.875 43.975 8.875C29.4364 8.875 17.65 20.6614 17.65 35.2C17.65 49.7386 29.4364 61.525 43.975 61.525C58.5136 61.525 70.3 49.7386 70.3 35.2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9249 55.211H7.97495C4.37135 55.211 1.44995 52.2896 1.44995 48.686V11.4143C1.44995 7.81065 4.37135 4.88925 7.97495 4.88925H66.9249C70.5285 4.88925 73.45 7.81065 73.45 11.4143V48.686C73.45 52.2896 70.5285 55.211 66.9249 55.211Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3951 50.8137H39.5045",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44995 46.8069H73.45",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5321 63.2608L31.28 55.186",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.62 55.1863L44.3679 63.2611",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4368 63.2609H51.4637",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2795 15.7656L63.1667 9.65189",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0781 15.8245L57.3478 10.0933",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8094 21.555L63.0782 15.8247",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.66 3.29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4008 41.6275V29.5927H51.43V41.6275",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.429 41.6274V20.4099H56.4582V41.6274",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4581 41.6275V25.6876H61.4873V41.6275",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2671 41.6275V35.6677H46.2972V41.6275",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7721 28.7471V41.6279H33.3326",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8107 37.958L19.9445 30.5898L22.1099 34.7649L24.0476 31.8048L26.159 33.2214L28.1858 28.5378L32.2007 37.958",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4645 17.7001C26.4645 13.9318 23.4081 10.8763 19.6398 10.8763C15.8706 10.8763 12.816 13.9318 12.816 17.7001C12.816 21.4684 15.8706 24.5239 19.6398 24.5239C23.4081 24.5239 26.4645 21.4684 26.4645 17.7001Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6398 10.8763V17.7001H26.4645",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1047 13.1922H44.8691",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1047 22.1922H41.423",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1047 17.6922H44.8691",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8639 13.1922H34.0276",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8639 22.1922H34.0276",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8639 17.6922H34.0276",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.475 54.761H7.525C3.9214 54.761 1 51.8396 1 48.236V10.9643C1 7.36067 3.9214 4.43927 7.525 4.43927H66.475C70.0786 4.43927 73 7.36067 73 10.9643V48.236C73 51.8396 70.0786 54.761 66.475 54.761Z",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9451 50.3638H39.0545",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1 46.3569H73",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0822 62.8108L30.8301 54.736",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1699 54.7363L43.9178 62.8111",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9867 62.8108H51.0136",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8296 15.3156L62.7168 9.20187",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.628 15.3745L56.8977 9.64334",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3594 21.105L62.6282 15.3747",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.66 3.29"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9508 41.1774V29.1426H50.98V41.1774",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.979 41.1775V19.96H56.0082V41.1775",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0081 41.1774V25.2375H61.0373V41.1774",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8171 41.1775V35.2177H45.8472V41.1775",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3221 28.2971V41.1779H32.8826",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3607 37.5081L19.4945 30.1398L21.6599 34.3149L23.5976 31.3548L25.709 32.7714L27.7358 28.0878L31.7507 37.5081",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0145 17.2501C26.0145 13.4818 22.9581 10.4263 19.1898 10.4263C15.4206 10.4263 12.366 13.4818 12.366 17.2501C12.366 21.0184 15.4206 24.0739 19.1898 24.0739C22.9581 24.0739 26.0145 21.0184 26.0145 17.2501Z",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1898 10.4262V17.25H26.0145",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6548 12.7422H44.4192",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6548 21.7422H40.9731",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6548 17.2422H44.4192",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4138 12.7422H33.5775",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4138 21.7422H33.5775",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4138 17.2422H33.5775",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPerformancetesting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/performancetesting.d3c31f0c.svg";
export { ForwardRef as ReactComponent };